import { render, staticRenderFns } from "./wtr-case-list.vue?vue&type=template&id=2837d1e2&scoped=true&"
import script from "./wtr-case-list.vue?vue&type=script&lang=js&"
export * from "./wtr-case-list.vue?vue&type=script&lang=js&"
import style0 from "./wtr-case-list.vue?vue&type=style&index=0&id=2837d1e2&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2837d1e2",
  null
  
)

export default component.exports